import { FuelTypography } from '@frete.com/fuel-react';
import Logo from '~components/svgs/Logo';
import Grid from '../Grid';
import { Props } from './types';

function Header({ title, subtitle, logoPosition }: Props) {
  const alignLogo = logoPosition === 'left' ? 'row-reverse' : 'row';

  return (
    <Grid container justify="space-between" direction={alignLogo}>
      <Grid $fill>
        {title && (
          <FuelTypography size="heading-md" variant="bold">
            {title}
          </FuelTypography>
        )}
        {subtitle && (
          <FuelTypography size="body-md" color="neutral-default">
            {subtitle}
          </FuelTypography>
        )}
      </Grid>
      <Grid>
        <Logo />
      </Grid>
    </Grid>
  );
}

export default Header;
